import { useEffect } from 'react';
import ReactDOM from 'react-dom';

function ModalFullScreen({ children }) {
  const modalRoot = document.getElementById('fullScreenPopUp');
  const root = document.getElementById('divAppContainer');
  const bottomDrawer = document.getElementById('BottomDrawer');
  // const newPopUpChild = document.createElement("div");

  useEffect(() => {
    modalRoot.style.display = 'block';
    root.style.display = 'none';
    if (bottomDrawer) bottomDrawer.style.display = 'none';
    return () => {
      root.style.display = 'block';
      modalRoot.style.display = 'none';
      if (bottomDrawer) bottomDrawer.style.display = 'block';
    };
  }, []);

  return ReactDOM.createPortal(children, modalRoot);
}

export default ModalFullScreen;
